// Simulate API delay for mock data
export const mockApiDelay = (ms: number = 500) => 
  new Promise<void>((resolve) => {
    setTimeout(() => resolve(), ms)
  })

// Generic mock query function for React Query
export async function createMockQuery<T>(
  mockData: T,
  options?: {
    delay?: number
    shouldFail?: boolean
    errorMessage?: string
  }
): Promise<T> {
  const { delay = 500, shouldFail = false, errorMessage = 'Failed to fetch data' } = options || {}
  
  await mockApiDelay(delay)
  
  if (shouldFail) {
    throw new Error(errorMessage)
  }
  
  return mockData
}